var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',{staticClass:"border-right-zero border-top-1 kcp-name",attrs:{"colspan":_vm.colspan}},[_vm._t("default",function(){return [_vm._v("нет сведений")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }